//@flow
import { isSudo } from '../../helpers/permissions.helper';
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormInput from './../../components/Inputs/FormInput';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class PontoAtendimentoCrudListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Nome do Ponto de Atendimento"
            placeholder={'Nome'}
            id={'nome'}
            name="nome"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            value={entity.nome}
          />
        </FormGroup>

        {isSudo() && (
          <FormGroup className="col-12 col-xl-3">
            <FormInput
              label="Nome Cliente"
              placeholder={'Nome'}
              id={'clienteNome'}
              name="clienteNome"
              onChange={this.props.onChangeDate}
              type={'text'}
              size={12}
              value={entity.clienteNome}
            />
          </FormGroup>
        )}
      </React.Fragment>
    );
  }
}
